import Texts from './Texts.json';

export function getText(Sprache) {
  if (Sprache === 'de') {
    return Texts.de;
  }
  return Texts.en;
}
